import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSurveys, updateSurveys, getSurveyById } from "api/surveys.api";

export const getSurveysAsync = createAsyncThunk(
  "surveys/get-all",
  async (filters) => {
    const data = await getSurveys(undefined, filters);
    return data;
  },
);

export const getNextSurveysAsync = createAsyncThunk(
  "surveys/get-all-next",
  async ({ last, filters }) => {
    const data = await getSurveys(last, filters);
    return data;
  },
);

export const getSurveyByIdAsync = createAsyncThunk(
  "surveys/get-by-id",
  async (id) => {
    const survey = await getSurveyById(id);
    const response = await fetch(survey.content);
    const text = await response.text();
    return { ...survey, content: text };
  },
);

export const updateSurveyAsync = createAsyncThunk(
  "surveys/update",
  async ({ id, data }) => {
    await updateSurveys(id, data);
  },
);
